<div
  class="aba-leitor-cotainer"
  [ngClass]="{
    'aba-leitor-cotainer-ativado': guia.ativa,
    'aba-leitor-cotainer-desativado': !guia.ativa
  }"
>
  <p
    class="aba-leitor-titulo aba-leitor-titulo-overflow noselect"
    [ngClass]="{
      'aba-leitor-titulo-ativado': guia.ativa,
      'aba-leitor-titulo-desativado': !guia.ativa
    }"
    (click)="alternarPara($event)"
    [matTooltip]="guia.titulo"
  >
    {{ guia.titulo }}
  </p>

  <mat-icon
    *ngIf="guia.ativa"
    class="aba-leitor-Fechar-icon"
    svgIcon="xmark-circle"
    matTooltip="Fechar aba"
    (click)="fecharGuia($event)"
  ></mat-icon>
</div>
